globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Media = appCustomerSpace.Modals.Media || {};

appCustomerSpace.Modals.Media.SearchImageContent = (function(superClass) {

  utils.extend(SearchImageContent, superClass);

  function SearchImageContent() {
    SearchImageContent.__super__.constructor.apply(this, arguments);

    this.$imagesGrid = this.$html.find('#ic-tab-my-images .images-grid');
    this.$searchInput = this.$html.find('.search-input');
    this.$selectBtn = this.$html.find('.select-btn');
    this.$previewImage = this.$html.find('.preview-image');
    this.$previewPlaceholder = this.$html.find('.preview-placeholder');
    this.$previewMeta = this.$html.find('.preview-meta');
    this.$libraryPagination = this.$html.find('.library-pagination');
    this.$uploadBtn = this.$html.find('.upload-btn');
    this.$uploadContainer = this.$html.find('.upload-container');
    this.$searchClearBtn = this.$html.find('.search-clear-btn');

    this.$libraryImagesGrid = this.$html.find('.library-images-grid');

    this.$myImagesEmptyState = this.$html.find('#ic-tab-my-images .images-empty-state');
    this.$libraryEmptyState = this.$html.find('#ic-tab-library .images-empty-state');

    this.selectedImage = null;
    this.currentPage = 1;
    this.totalPages = 1;
    this.totalEntries = 0;
    this.imagesIndexUrl = this.$html.data('images-index-url');
    this.libraryImagesIndexUrl = this.$html.data('library-images-index-url');
    this.uploadUrl = this.$html.data('upload-url');
    this.activeTab = 'my-images';
    this.libraryLoaded = false;
    this.libraryCurrentPage = 1;
    this.libraryTotalPages = 1;
    this.libraryTotalEntries = 0;
    this.stimulusController = this.$html.data('stimulus-controller');
  }

  $.extend(SearchImageContent.prototype, {
    init: function() {
      var modal = this;
      modal._initEvents();
      modal._cacheTemplate();
      modal._initUploader();

      modal._loadImages(1);

      return SearchImageContent.__super__.init.apply(this, arguments);
    },

    _initEvents: function() {
      var modal = this;

      modal.$searchInput.on('keydown', function(e) {
        if (e.which === 13) {
          e.preventDefault();
          modal._performSearch();
        }
      });

      modal.$html.find('.search-bar-container .input-group-btn .btn:not(.search-clear-btn)').on('click', function() {
        modal._performSearch();
      });

      modal.$searchInput.on('input', function() {
        modal.$searchClearBtn.toggle($(this).val().length > 0);
      });

      modal.$searchClearBtn.on('click', function() {
        modal.$searchInput.val('');
        modal.$searchClearBtn.hide();
        modal._performSearch();
      });

      modal.$imagesGrid.on('click', '.image-item', function() {
        modal._selectImage($(this));
      });

      modal.$html.find('.library-images-grid').on('click', '.image-item', function() {
        modal._selectImage($(this));
      });

      // Hover preview
      var mouseenterTimeout, mouseleaveTimeout;

      modal.$html.on('mouseenter', '.images-grid .image-item:not(.template)', function() {
        var $item = $(this);
        if (mouseenterTimeout) clearTimeout(mouseenterTimeout);
        if (mouseleaveTimeout) clearTimeout(mouseleaveTimeout);

        mouseenterTimeout = setTimeout(function() {
          modal._previewImage($item);
        }, 200);
      }).on('mouseleave', '.images-grid .image-item:not(.template)', function() {
        if (mouseleaveTimeout) clearTimeout(mouseleaveTimeout);

        mouseleaveTimeout = setTimeout(function() {
          modal._restorePreview();
        }, 400);
      });

      modal.$selectBtn.on('click', function() {
        if (modal.selectedImage) {
          modal._submitSelection();
        }
      });

      modal.$libraryPagination.on('click', '.pagination-prev:not(:disabled)', function() {
        if (modal.activeTab === 'library') {
          modal._loadLibraryImages(modal.libraryCurrentPage - 1);
        } else {
          modal._loadImages(modal.currentPage - 1);
        }
      });

      modal.$libraryPagination.on('click', '.pagination-next:not(:disabled)', function() {
        if (modal.activeTab === 'library') {
          modal._loadLibraryImages(modal.libraryCurrentPage + 1);
        } else {
          modal._loadImages(modal.currentPage + 1);
        }
      });

      modal.$libraryPagination.on('change', '.pagination-page-select', function() {
        var page = parseInt($(this).val(), 10);
        if (modal.activeTab === 'library') {
          modal._loadLibraryImages(page);
        } else {
          modal._loadImages(page);
        }
      });

      modal.$html.find('.image-content-tabs').on('shown.bs.tab', 'a[data-toggle="tab"]', function(e) {
        var tabId = $(e.target).attr('href');
        if (tabId === '#ic-tab-library') {
          modal.activeTab = 'library';
          modal.$uploadContainer.hide();
          modal._clearSelection();
          if (!modal.libraryLoaded) {
            modal._loadLibraryImages(1);
          } else {
            modal._renderLibraryPagination();
          }
        } else {
          modal.activeTab = 'my-images';
          modal.$uploadContainer.show();
          modal._clearSelection();
          modal._renderPagination();
        }
      });
    },

    _initUploader: function() {
      var modal = this;

      modal.uploader = new Uploader(modal.$html, {
        data: { context: 'selection' },
        progress: {
          percent: '.file-percent',
          progressbar: '.file-progressbar'
        },
        plupload: {
          drop_element: modal.$imagesGrid[0],
          browse_button: modal.$uploadBtn[0],
          multi_selection: true,
          url: modal.uploadUrl,
        },
        callbacks: {
          filesAdded: function(up, files) {
            var files = Array.prototype.slice.call(files).reverse();
            for (var i = files.length - 1; i >= 0; i--) {
              modal._renderPreview(files[i]);
            }
          },
          uploadProgress: function(up, file) {
            var $preview = modal.$imagesGrid.find('#' + file.id),
                percent = file.percent + '%';
            $preview.find(this.config.progress.percent).text(percent).end()
                    .find(this.config.progress.progressbar).css('width', percent);
          },
          fileUploaded: function(up, file, response) {
            if (response.error) {
              modal.$imagesGrid.find('#' + file.id).addClass('error')
                .find(this.config.progress.percent).text(response.error);
              setTimeout(function() {
                modal.$imagesGrid.find('#' + file.id).fadeOut(200, function() { $(this).remove(); });
              }, 5000);
            } else {
              modal.$imagesGrid.find('#' + file.id).fadeOut(200, function() { $(this).remove(); });
            }
          },
          uploadComplete: function() {
            modal.$imagesGrid.children('.image-item').remove();
            modal._loadImages(1);
          },
          error: function(up, err) {
            console.error('Upload error:', err.message);
          }
        }
      });
    },

    _performSearch: function() {
      var modal = this;
      if (modal.activeTab === 'library') {
        modal.$libraryImagesGrid.children('.image-item').remove();
        modal.libraryLoaded = false;
        modal._loadLibraryImages(1);
      } else {
        modal.$imagesGrid.children('.image-item').remove();
        modal._loadImages(1);
      }
    },

    _loadImages: function(page) {
      this._loadImagesFor({
        page: page,
        url: this.imagesIndexUrl,
        $grid: this.$imagesGrid,
        $emptyState: this.$myImagesEmptyState,
        imageType: 'Accounts::Media::Image',
        onSuccess: function(modal, data) {
          modal.currentPage = data.current_page;
          modal.totalPages = data.total_pages;
          modal.totalEntries = data.total_entries;
          modal._renderPagination();
        }
      });
    },

    _renderPagination: function() {
      this._renderPaginationFor({
        currentPage: this.currentPage,
        totalPages: this.totalPages,
        totalEntries: this.totalEntries
      });
    },

    _selectImage: function($imageItem) {
      var modal = this;

      modal.$imagesGrid.find('.image-item').removeClass('selected');
      modal.$libraryImagesGrid.find('.image-item').removeClass('selected');
      $imageItem.addClass('selected');

      modal.selectedImage = {
        id: $imageItem.data('id'),
        type: $imageItem.data('type'),
        medium_url: $imageItem.data('medium-url'),
        label: $imageItem.data('label'),
        width: $imageItem.data('width'),
        height: $imageItem.data('height')
      };

      modal._previewImage($imageItem);
      modal.$selectBtn.prop('disabled', false);
    },

    _previewImage: function($imageItem) {
      var modal = this;
      var mediumUrl = $imageItem.data('medium-url');
      var label = $imageItem.data('label');
      var width = $imageItem.data('width');
      var height = $imageItem.data('height');
      var $img = modal.$previewImage.find('img');

      modal.$previewPlaceholder.hide();
      modal.$previewMeta.show();
      modal.$previewMeta.find('.filename').text(label || 'Image');
      if (width && height) {
        modal.$previewMeta.find('.label-dimensions').text(width + ' x ' + height + ' px');
      } else {
        modal.$previewMeta.find('.label-dimensions').text('');
      }

      if ($img.attr('src') !== mediumUrl) {
        $img.stop(true).fadeTo(80, 0, function() {
          $img.attr('src', mediumUrl);
          modal.$previewImage.show();
          $img.fadeTo(120, 1);
        });
      } else {
        modal.$previewImage.show();
      }
    },

    _restorePreview: function() {
      var modal = this;
      var $img = modal.$previewImage.find('img');
      $img.stop(true);

      if (modal.selectedImage) {
        modal.$previewPlaceholder.hide();
        modal.$previewMeta.show();
        modal.$previewMeta.find('.filename').text(modal.selectedImage.label || 'Image');
        if (modal.selectedImage.width && modal.selectedImage.height) {
          modal.$previewMeta.find('.label-dimensions').text(
            modal.selectedImage.width + ' x ' + modal.selectedImage.height + ' px'
          );
        } else {
          modal.$previewMeta.find('.label-dimensions').text('');
        }

        if ($img.attr('src') !== modal.selectedImage.medium_url) {
          $img.fadeTo(80, 0, function() {
            $img.attr('src', modal.selectedImage.medium_url);
            modal.$previewImage.show();
            $img.fadeTo(120, 1);
          });
        } else {
          modal.$previewImage.show();
          $img.fadeTo(120, 1);
        }
      } else {
        modal.$previewImage.hide();
        modal.$previewMeta.hide();
        modal.$previewPlaceholder.show();
      }
    },

    _renderPreview: function(image) {
      if (image) {
        var modal = this,
            preview = modal._$template().clone().attr('id', image.id);
        preview.css('height', 80);
        modal.$imagesGrid.prepend(preview.fadeIn(90));
      }
    },

    _cacheTemplate: function() {
      this._templateHtml = this.$imagesGrid.find('template').html().trim();
    },

    _$template: function() {
      return $(this._templateHtml);
    },

    _clearSelection: function() {
      var modal = this;
      modal.$imagesGrid.find('.image-item').removeClass('selected');
      modal.$libraryImagesGrid.find('.image-item').removeClass('selected');
      modal.selectedImage = null;
      modal.$previewImage.hide();
      modal.$previewMeta.hide();
      modal.$previewPlaceholder.show();
      modal.$selectBtn.prop('disabled', true);
    },

    _loadLibraryImages: function(page) {
      var modal = this;
      this._loadImagesFor({
        page: page,
        url: this.libraryImagesIndexUrl,
        $grid: this.$libraryImagesGrid,
        $emptyState: this.$libraryEmptyState,
        imageType: 'Library::Image',
        onSuccess: function(modal, data) {
          modal.libraryCurrentPage = data.current_page;
          modal.libraryTotalPages = data.total_pages;
          modal.libraryTotalEntries = data.total_entries;
          modal.libraryLoaded = true;
          modal._renderLibraryPagination();
        }
      });
    },

    _renderLibraryPagination: function() {
      this._renderPaginationFor({
        currentPage: this.libraryCurrentPage,
        totalPages: this.libraryTotalPages,
        totalEntries: this.libraryTotalEntries
      });
    },

    _loadImagesFor: function(opts) {
      var modal = this;
      var search = modal.$searchInput.val();

      $.ajax({
        url: opts.url,
        dataType: 'json',
        data: { page: opts.page, per_page: 20, search: search },
        success: function(data) {
          opts.$grid.children('.image-item').remove();

          data.images.forEach(function(image) {
            var $item = $('<div class="image-item" />')
              .attr('data-id', image.id)
              .attr('data-type', opts.imageType)
              .attr('data-medium-url', image.medium_url)
              .attr('data-label', image.label || '')
              .attr('data-width', image.file_width || '')
              .attr('data-height', image.file_height || '');

            var $thumb = $('<div class="thumbnail" />');
            var $img = $('<img />')
              .attr('src', image.thumbnail_url)
              .attr('alt', image.label || '');

            $thumb.append($img);
            $item.append($thumb);
            opts.$grid.append($item);
          });

          opts.$grid[0].offsetHeight; // force reflow before animation
          opts.$grid.find('.image-item').each(function(index) {
            $(this).css('animation-delay', (index * 30) + 'ms').addClass('fade-in');
          });

          if (opts.$emptyState) {
            opts.$emptyState.toggle(data.images.length === 0);
          }

          opts.onSuccess(modal, data);
          opts.$grid.scrollTop(0);
        }
      });
    },

    _renderPaginationFor: function(opts) {
      var modal = this;

      if (opts.totalPages <= 1) {
        modal.$libraryPagination.hide();
        return;
      }

      modal.$libraryPagination.find('.pagination-count').text(opts.totalEntries + ' images');
      modal.$libraryPagination.find('.pagination-page-current').text(opts.currentPage);
      modal.$libraryPagination.find('.pagination-page-total').text(opts.totalPages);

      var $select = modal.$libraryPagination.find('.pagination-page-select');
      $select.empty();
      for (var i = 1; i <= opts.totalPages; i++) {
        $select.append($('<option />').val(i).text(i).prop('selected', i === opts.currentPage));
      }

      modal.$libraryPagination.find('.pagination-prev').prop('disabled', opts.currentPage <= 1);
      modal.$libraryPagination.find('.pagination-next').prop('disabled', opts.currentPage >= opts.totalPages);
      modal.$libraryPagination.show();
    },

    _submitSelection: function() {
      var modal = this;
      if (!modal.selectedImage) return;

      var csrfToken = $('meta[name="csrf-token"]').attr('content');
      var stimulusController = modal.stimulusController;
      var createUrl = stimulusController ? stimulusController.createUrlValue : '/media/image_contents';

      $.ajax({
        url: createUrl,
        method: 'POST',
        dataType: 'json',
        headers: { 'X-CSRF-Token': csrfToken },
        data: {
          source_image_id: modal.selectedImage.id,
          source_image_type: modal.selectedImage.type,
          owner_type: stimulusController ? stimulusController.ownerTypeValue : '',
          owner_id: stimulusController ? stimulusController.ownerIdValue : '',
          owner_association: stimulusController ? stimulusController.ownerAssociationValue : '',
          ai: stimulusController ? stimulusController.isAi : false,
          aspect_ratios: stimulusController ? stimulusController.aspectRatiosValue.join(",") : ""
        },
        success: function(data) {
          if (data.response && stimulusController) {
            stimulusController.handleImageSelected(data.image_content, data.component_body_html);
          }
          modal.close();
        },
        error: function() {
          console.error('Error creating image content');
        }
      });
    }
  });

  return SearchImageContent;

})(appCustomerSpace.Modal);
